import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import MatchDots from '../../components/ExcerciseTypes/LineTo/MatchDots';


const json = {
  1: { // Exercise num
    unit: 'Unit 1',
    id: 'WB3-U1-P8-E1',
    audio: 'img/FriendsPlus/Page8/Audio/audio-e1-p8.mp3',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page8/E1/Key/answerKey.png',
    component: MatchDots,
    titleQuestion: [{ num: '1', title: 'Listen and draw lines.<headphone name="01" src="img/FriendsPlus/Page8/Audio/tieude-e1-p8.mp3"></headphone>', color: "#5B5A5D" }],

    question: {
      DrawLines: {
        multipleLine: true,
        boxMatch: [

          { boxMatchStyle: { position: 'absolute', top: '86px', left: '1207px', width: 120, height: 100 } },// sách
          { boxMatchStyle: { position: 'absolute', top: '315px', left: '128px', width: 116, height: 127 }, },//màn`
          { boxMatchStyle: { position: 'absolute', top: '315px', left: '1208px', width: 126, height: 120 }, },//but
          { boxMatchStyle: { position: 'absolute', top: '558px', left: '130px', width: 129, height: 120 }, },//áo
          { boxMatchStyle: { position: 'absolute', top: '558px', left: '1208px', width: 129, height: 120 }, },//gấu

          // { boxMatchStyle: { position: 'absolute', top: '271px', left: '381px', width: 177, height: 196, border: 'dashed' }, },//bàn 
          { boxMatchStyle: { position: 'absolute', top: '181px', left: '398px', width: 142, height: 33, border: '0.5px dashed black' }, },//bàn = đổi qua kệ
          { boxMatchStyle: { position: 'absolute', top: '428px', left: '849px', width: 334, height: 160, border: '0.5px dashed black' }, },//giường
          { boxMatchStyle: { position: 'absolute', top: '217px', left: '587px', width: 234, height: 257, border: '0.5px dashed black' }, },//tủ quần áo
          { boxMatchStyle: { position: 'absolute', top: '435px', left: '529px', width: 276, height: 135, border: '0.5px dashed black' }, },//tấm thảm
        ],
        answers: ['0-5', '1-6', '2-5', '3-7', '4-8'],
        initialValue: [],
      },
      Layout: `
          <img src='img/FriendsPlus/Page8/E1/1.jpg' />
          <input id='0' type= 'boxMatch' />
          <input id='1' type= 'boxMatch' />
          <input id='2' type= 'boxMatch' />
          <input id='3' type= 'boxMatch' />
          <input id='4' type= 'boxMatch' />

          <input id='5' type= 'boxMatch' />
          <input id='6' type= 'boxMatch' />
          <input id='7' type= 'boxMatch' />
          <input id='8' type= 'boxMatch' />
      `,
    },
  },
  2: { // Exercise num
    unit: 'Unit 1',
    id: 'WB3-U1-P8-E2',
    audio: '',
    video: '',
    component: D1,
    checkUppercase: true,
    exerciseKey: 'img/FriendsPlus/Page8/E2/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page8/E2/1.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page8/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page8/E2/3.jpg', input: true, answer: "the shelf" },
        { url: 'img/FriendsPlus/Page8/E2/4.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page8/E2/5.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page8/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page8/E2/7.jpg', input: true, answer: "It's on the bed." },
        { url: 'img/FriendsPlus/Page8/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page8/E2/9.jpg', input: true, answer: "It's on the shelf." },
      ],
      [
        { url: 'img/FriendsPlus/Page8/E2/10.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page8/E2/11.jpg' },
        { url: 'img/FriendsPlus/Page8/E2/12.jpg', input: true, answer: "It's in the cabinet." },
        { url: 'img/FriendsPlus/Page8/E2/13.jpg' },
        { url: 'img/FriendsPlus/Page8/E2/14.jpg', input: true, answer: "It's on the rug." },
      ],
    ]
  },
}

export default json;